import Menu from '@/models/menu'

export default class MenuFactory {
    static createFromJson(json) {
        return new Menu(json)
    }
    static createFromJsonArray(jsonArray) {
        const jsonData = []
        jsonArray.forEach(item => {
            jsonData.push(MenuFactory.createFromJson(item))
        })

        return jsonData
    }
}
